import { useStatefulFormField } from "csi/middleware/form/index";
import { createContext, FC, MutableRefObject, RefObject, useContext, useEffect, useRef } from "react";

/** Hook to wrap component based on the existence of field in context */
export const useFieldWrapper = <AProps extends {}, BProps extends {}>(BaseComponent: FC<AProps>, FormFieldComponent: FC<BProps>): FC<AProps> | FC<BProps> => {
	const field = useStatefulFormField();
	return field ? FormFieldComponent : BaseComponent;
};

/** using useEffect to prevent component to fire an onChangeCallBack. The first callback from the Design System Mutli Select will overwrite pre selected values */
export const useIsMounted = (): MutableRefObject<boolean> => {
	const isMounted = useRef(false);
	useEffect(() => {
		isMounted.current = true;
		return () => {
			isMounted.current = false;
		};
	}, []);
	return isMounted;
};

/** call set ref callback on component mount and cleanup */
export const useSetRefOnMount = <T extends Element>(setRef?: (ref: RefObject<T>) => void): RefObject<T> => {
	const containerRef = useRef<T>(null);
	useEffect(() => {
		setRef(containerRef);
		return () => {
			setRef(null);
		};
	}, []);
	return containerRef;
};

/** Context to determine if there exists a component overlay */
export const ComponentOverlayContext = createContext<boolean>(false);
export const useComponentOverlayContext = (): boolean => useContext(ComponentOverlayContext);
